import { BaseGlobalSchema } from './baseGlobal.schema';
import z from 'zod';

const IconSchema = z
  .object({
    url: z.string().url(),
    alt: z.string().nullable(),
  })
  .nullable();

const CompanyInformationSocialMediaSchema = z.object({
  icon: IconSchema,
  url: z.string().url(),
  title: z.string().nullable(),
});

export const CompanyInformationDataSchema = BaseGlobalSchema.extend({
  abn: z.string(),
  social_media: z.array(CompanyInformationSocialMediaSchema),
  support_phone: z.string(),
});
